import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerTodosLosUsuarios, registrarUsuario,setPrueba } from '../../redux/UsuariosDcuks'
import { DataGrid } from '@mui/x-data-grid';
import { withRouter } from 'react-router-dom'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { useStateIfMounted } from 'use-state-if-mounted';
import { Paper} from '@mui/material';

function UsuariosMain(props) {

    const dispatch = useDispatch()

    const [disabled, setDisabled] = useStateIfMounted(false)
    const [usuario, setusuario] = useStateIfMounted('')
    const [password, setpassword] = useStateIfMounted('')
    const [idtipousuario, setidtipousuario] = useStateIfMounted(0)
    const [idrol, setidrol] = useStateIfMounted('')
    const [show, setShow] = useState(false);
    let rows = [];
    const usuarios = useSelector(store => store.Usuarios.usuarios)
    
    React.useEffect(() => {
        dispatch(obtenerTodosLosUsuarios())
    }, [])
    
    usuarios?.map(usr => (
        rows.push({id:usr.idlogin, usuario:usr.usuario ,tipoUsuario: usr.tipousuario.usuario,
        idtipousuario: usr.tipousuario.idtipousuario})
    ))
    // async function editarUsuario(params) {
    //     setusuario(params.row.usuario)
    //     setpassword(params.row.password)
    //     setidtipousuario(params.row.idtipousuario)
    //     setDisabled(true)
    //     handleModalOpen(true)
    // }

    const columns = [
        { field: 'usuario', headerName: 'Usuario', width: 250 },
        { field: 'tipoUsuario', headerName: 'Tipo de usuario', width: 160 },
        // {
        //     field: 'accionEditar', headerName: 'Editar', width: 200,
        //     renderCell: (params) => (
        //         <button onClick={() => editarUsuario(params)} className='btn btn-warning btn-sm'>Cambiar tipo de usuario</button>
        //     )
        // },
        // {
        //     field: 'accionEliminar', headerName: 'Eliminar', width: 120,
        //     renderCell: (params) => (
        //         <button className="btn btn-danger btn-sm">Eliminar</button>
        //     )
        // }
    ]

    const handleModalClose = (e) => {
        const currentClass = e.target.className;
        if (currentClass === 'modal-card') {
            return;
        }
        setShow(false);
    };


    const botonAgregarUsuario = async () => {
        let idRol = idtipousuario === 1 || 2 ? (2) : (idtipousuario)
        await dispatch(registrarUsuario({usuario,password,idtipousuario:Number(idtipousuario),idrol:Number(idRol)}))
        await dispatch(obtenerTodosLosUsuarios())
        setShow(false)
    }

    const handleModalOpen = () => {
        setusuario('')
        setpassword('')
        setidtipousuario('0')
        setDisabled(false)
        setShow(true);
    };

    return (

        <div className='container mt-1 ms-1'>
            <div className="index">

                <div align="right">
                    <IconButton
                        size="large"
                        edge="end"
                        label="Agregar usuario"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleModalOpen}

                    >
                        <AddCircleIcon />
                    </IconButton>
                </div>
                <div className='row justify-content-md-center mb-2'>
                    <Paper sx={{ backgroundColor: '#504E43', width: '100%' }}>
                        <h6 className='text-center text-light'>Usuarios</h6>
                    </Paper>
                </div>
                <div style={{ height: 600, width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                    />
                    <div hidden={!show}>
                        <div className="modal-background mt-5">
                            <div className="modal-card">
                                <div align='center'><b>REGISTRO DE USUARIO</b></div>
                                <div className="row align-items-center">
                                    <div className="col">
                                        <label>Correo electronico:</label>
                                    </div>
                                    <div className="col">
                                        <input type="text" id="" placeholder='ejemplo@gmail.com' 
                                        value={usuario} onChange={e => setusuario(e.target.value)} />
                                    </div>
                                </div>

                                <div className="row align-items-center">
                                    <div className="col">
                                        <label>Contraseña:    </label>
                                    </div>
                                    <div className="col">
                                        <input type="text" id="" placeholder='Contraseña' 
                                        value={password} onChange={e => setpassword(e.target.value)} />
                                    </div>
                                </div>
                                
                                <div>
                                    <label className="form-label">Tipo usuario:</label>
                                    <select className="form-select" value={idtipousuario} onChange={e => setidtipousuario(e.target.value)}>
                                        <option value='0'>Tipo de Usuario</option>
                                        <option value="1">Beneficiario basico</option>
                                        <option value="2">Beneficiario premium</option>
                                        <option value="3">Atencion a clientes</option>
                                    </select>
                                </div>
                                <div align='center'>
                                    <br />
                                    <button
                                        type='submit'
                                        className='btn btn-dark'
                                        onClick={botonAgregarUsuario}> Guardar
                                    </button>
                                    <br/>
                                    <button
                                        type='submit'
                                        className='btn btn-dark mt-2'
                                        onClick={handleModalClose}> Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withRouter(UsuariosMain)
